import { GetterTree } from 'vuex'
import { StatisticsState } from './state'
import { StringKeys } from '../../types'

const getters: GetterTree<StatisticsState, {}> = {
  courseHistoryStats: state => {
    const { courseHistoryStats: stats } = state
    if (stats && stats.all_courses_video_time_watched) {
      return stats.all_courses_video_time_watched
    }
    return stats
  },
  formattedChart: state => {
    const {
      yearlyStats: { time_watched_chart: chart },
    } = state
    if (chart && Object.keys(chart).length) {
      return Object.keys(chart).reduce((acc: StringKeys, key) => {
        acc[key] = Math.ceil(chart[key] / 60)
        return acc
      }, {})
    }
    return chart
  },
}

export default getters
